import { render } from "./recommendation-box.vue?vue&type=template&id=12ae1ed7&scoped=true"
import script from "./recommendation-box.vue?vue&type=script&lang=js"
export * from "./recommendation-box.vue?vue&type=script&lang=js"

import "./recommendation-box.vue?vue&type=style&index=0&id=12ae1ed7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ae1ed7"]])

export default __exports__